export default __webpack_public_path__ + "0ebd23d2e8296006ae5f54da96e76584.svg";